import { ModelUI } from './model-ui';
import { ReactModel } from '../react-model/react-model';

type KS<T> = Extract<keyof T, string>;
type TFuncUI<T> = (scope: ModelUI<T>, index: number) => React.ReactElement;

export function HBlock<T>(props: {
	state?: T;
	model?: ReactModel<T>;
	array_item_key: (T extends any[] ? KS<T[0]> : KS<T>) | '$index';
	onRender: TFuncUI<T extends any[] ? T[0] : T>;
}): React.ReactElement;
export function HBlock<T>(props: { state?: T; model?: ReactModel<T>; onRender: TFuncUI<T> }): React.ReactElement;
export function HBlock<T>(props: { state?: T; model?: ReactModel<T>; array_item_key?: any; onRender: TFuncUI<T> }): React.ReactElement {
	if (props.model) {
		var model_ui: ModelUI<T> = ModelUI.fromModel(props.model);
	} else if (props.state) {
		model_ui = ModelUI.fromState(props.state) as ModelUI<T>;
	} else throw Error('One of model and state should be provided');
	//re-render on change
	{
		model_ui.model.useModel();
	}
	return model_ui.render(props.onRender, props.array_item_key);
}
